var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5989 20.5H3.37869C1.7111 20.5 0.354492 19.0982 0.354492 17.375V6.78908C0.354492 5.06588 1.7111 3.66407 3.37869 3.66407H10.5989C12.2665 3.66407 13.6231 5.06588 13.6231 6.78908V17.375C13.6231 19.0982 12.2665 20.5 10.5989 20.5ZM3.37869 5.22657C2.54497 5.22657 1.86659 5.92755 1.86659 6.78908V17.375C1.86659 18.2365 2.54497 18.9375 3.37869 18.9375H10.5989C11.4327 18.9375 12.111 18.2365 12.111 17.375V6.78908C12.111 5.92755 11.4327 5.22657 10.5989 5.22657H3.37869ZM16.6473 15.4218V3.625C16.6473 1.90182 15.2907 0.5 13.6231 0.5H5.23102C4.81344 0.5 4.47497 0.849733 4.47497 1.28125C4.47497 1.71277 4.81344 2.0625 5.23102 2.0625H13.6231C14.4569 2.0625 15.1352 2.76349 15.1352 3.625V15.4218C15.1352 15.8534 15.4737 16.2032 15.8913 16.2032C16.3089 16.2032 16.6473 15.8534 16.6473 15.4218Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.6e8b60d099e810fe6a6ae6bc739684d2.svg";
export { ForwardRef as ReactComponent };